import FormHelperText from '@mui/material/FormHelperText';
import { styled } from '@mui/material/styles';

const Label = styled(FormHelperText)(() => ({
  fontWidth: '600',
  fontSize: 'medium',
  color: ' #000',
  marginLeft: '0px',
}));

export default Label;
